<template>
    <div class="list-item">
        <div class="prop">
            <span class="label">Request ID:</span>
            <span>{{ data.id }}</span>
        </div>
        <div class="prop">
            <span class="label">Items:</span>
            <span>{{ data.tap_banknotes[0] ? data.tap_banknotes[0].product.name : '' }}</span>
        </div>
        <div class="prop">
            <span class="label">Registered At:</span>
            <span>{{ data.created_at }},{{ data.created_time_at }}</span>
        </div>
        <div class="prop">
            <span class="label">Owner Note:</span>
            <span>{{ data.owner_note }}</span>
        </div>
        <div class="prop">
            <span class="label">Status:</span>
            <span>{{ data.status }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "Card",
    props: ['data']
}
</script>

<style scoped lang="scss">
.list-item {
    background-color: #F3F3F3;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    padding: 20px 10px;
    gap: 10px;

    .prop {
        display: flex;
        gap: 10px;

        .label {
            min-width: 10rem;
        }
    }
}
</style>
